import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import { Table } from 'react-bootstrap';
import Moment from 'react-moment';
import {filePdf} from 'react-icons-kit/icomoon/filePdf';
import SvgIcon from 'react-icons-kit';
import Loader from 'react-loader-spinner';
import swal from 'sweetalert';
import Notifications, {notify} from 'react-notify-toast';
import {checkmark} from 'react-icons-kit/icomoon/checkmark';

var Config = require('../../../config');

class ModalSingleValidation extends Component{
	constructor(props, context) {
		super(props, context);
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.save = this.save.bind(this);
		this.getResults = this.getResults.bind(this);
		this.getResultValues = this.getResultValues.bind(this);

		this.state = {
		    show: false,
		    donation_id:"",
		    lab_section_id:"",
		    opening:false,
		    lab_section_name:"",
		    data:{},
		    analitical_test_list:[],
		    samples_id:"",
		    sample:{},
		    results:[],
		    can_save:true,
		    lab_sections:[]
		};
	}

	componentDidMount() {
		this.props.onRef(this);

		this.setState({lab_sections: JSON.parse(sessionStorage.getItem("lab_sections_has_user_profiles"))})

	}

	componentWillUnmount() {
		this.props.onRef(null)
	}

	handleClose() {
		this.setState({ show: false,donation_id:"",lab_section_id:"",lab_section_name:"",samples_id:""});
	}

	handleShow(donation_id, lab_section_id, lab_section_name, samples_id) {
		this.setState({ 
			show: true,
			donation_id:donation_id, 
			lab_section_id:lab_section_id,
			opening:true,
			lab_section_name:lab_section_name,
			samples_id:samples_id });

		
		var index = this.state.lab_sections.findIndex(obj => obj.lab_sections_id === lab_section_id);

		if(index !== -1){
			if(!this.state.lab_sections[index].modify){
				this.setState({
					can_save: false
				})
			}
		}else{
			this.setState({
				can_save: false
			})
		}
		
		setTimeout(()=>{
			this.loadData(donation_id, lab_section_id, samples_id);
		}, 300);
		
	}

	loadData(donation_id, section_id, samples_id){
		fetch(Config.default.apiGateway.URL+'lab_sections/single_validation?donation_id='+donation_id+"&lab_sections_id="+section_id+"&samples_id="+samples_id,{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(res => {
			this.setState({opening:false});
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error!', result, 'error');
              });
            }})
		.then(response => {
			this.setState({data:response, analitical_test_list:response.section.analitical_test_list});
			if(this.state.samples_id !== 0){
				this.getResultValues();
			}
		})
	}

	getResultValues(){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'samples/'+this.state.samples_id, {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Typet'	: 'application/json'
			})
		})
		.then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}})
		.catch(error => console.error('Error:', error))
		.then(response => {
			this.setState({
				sample: response.sample,
				results: response.results,
				//donor_age: response.donor_age,
				//data: {donation_number: response.sample.number},
			});

			this.state.data.donor_age = response.donor_age;
			//this.state.data.donation_number = response.sample.number;
			this.forceUpdate();

			setTimeout(function(){
				response.results.map(function(r, i){
					console.log()
					if(document.getElementById("analitical_test_"+r.analitical_test_id) !== null){
						if(r.validated){
							document.getElementById('mark_'+r.analitical_test_id).style.display = "block";
							document.getElementById("analitical_test_"+r.analitical_test_id).disabled = true;
						}

						document.getElementById("analitical_test_"+r.analitical_test_id).value = r.value;

						var control = document.getElementById("analitical_test_"+r.analitical_test_id);
						
						this.validateElement(control);
					}

				}.bind(this));
			}.bind(this), 500);
		});
	}

	//desplegar errores en selceted
	showCtrlError(refName) {
	    var res = null;
	    var control = document.getElementById(refName);

	    if(control !== null){
		    if (control.value === null || control.value === "") {
		      control.classList.add('error');
		      res = false;
		    } else{
		      control.classList.remove('error');
		      res = true;
		    }
		}

	    return res;
	}

	getResults(){
		var res = [];
		var obj = {};

		if(this.state.samples_id !== 0){
			
			this.state.analitical_test_list.map((test)=>{
				if(document.getElementById("analitical_test_"+test.analitical_test.id) !== null){

					var objIndex = this.state.results.findIndex((obj => obj.analitical_test_id === test.analitical_test.id));

					if(objIndex !== -1){
						obj = {};
						obj.id = this.state.results[objIndex].id;
						obj.value = document.getElementById("analitical_test_"+this.state.results[objIndex].analitical_test_id).value;
						obj.sample_types_id = this.state.results[objIndex].sample_types_id;
						obj.samples_id = this.state.results[objIndex].samples_id;
						obj.analitical_test_id = this.state.results[objIndex].analitical_test_id;
						obj.validated = this.state.results[objIndex].validated;
						if(obj.value !== ""){
							res.push(obj);
						}
					}else{
						obj = {};
						obj.validated = false;
						obj.samples_id = this.state.samples_id;
						obj.value = document.getElementById("analitical_test_"+test.analitical_test.id).value;
						obj.analitical_test_id = test.analitical_test.id;
						if(obj.value !== ""){
							res.push(obj);
						}
					}

				}
			})

		}else{
			var analitical_test_list = this.state.analitical_test_list;
			for(var j=0; j< analitical_test_list.length;j++){
				obj = {};
				obj.validated = false;
				obj.value = document.getElementById("analitical_test_"+analitical_test_list[j].analitical_test.id).value;
				obj.analitical_test_id = analitical_test_list[j].analitical_test.id;
				if(obj.value !== ""){
					res.push(obj);
				}
			}
		}

		return res;
	}

	//Funcion Submit Form
	save(e){
		e.preventDefault();
		var items = this.getResults();
		if(items.length > 0){
			var aux_date = new Date();
			var method="";
			var path = "";
			if(this.props.state.start_date===""){
				this.props.state.start_date=aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2);
    		}
    		this.setState({opening:true});
    		if(this.state.samples_id !== 0){
    			method = "PUT";
    			path = 'sample_results?sample_id='+this.state.samples_id;
    		}else{
    			method = "POST";
    			path = 'sample_results?donation_id='+this.state.donation_id;
    		}
    		
	      	fetch(Config.default.apiGateway.URL+path, {
			  method: method,
			  body: JSON.stringify(items), // data can be `string` or {object}!
			  headers: new Headers({
			  	'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
			  	'Accept': 'application/json',
			  	'Content-Type': 'application/json;charset=UTF-8'
			  })
			}).then(res => {
				this.setState({opening:false});
				if(res.ok){
					return res.json();
				}console.log(res)})
			.catch(error => console.error('Error:', error))
			.then(response => {
		    	if(response !== undefined){
		    		notify.show('Registro Guardado','success');

		    		this.props.refresh();
		    		this.handleClose();
		    	}else{
		    		swal('¡Error!', '¡No se pudo guardar!', 'error');
		    	}
			});
		}else{
			swal('¡Error!', '¡No ha registrado ningún resultado!', 'error');
		}
	    
	}

	//Verificar si el formulario es valido
	isValidForm() {
		const inputs = document.querySelectorAll('select,input');
	    let isFormValid = true;

	    inputs.forEach(input => {
	    	if(input.required && input.name !== "new_value" && input.name !== "analitical_test_id" ){
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		  	}
	    });

	    return isFormValid;
	}

	//Evento de cambio en elementos formulario
	handleChange = (event) => {

		if(event.target.id !== null){
			var control = document.getElementById(event.target.id);
			if(control !== null){
				if(event.target.name.indexOf('analitical_test_') !== -1){
					this.validateElement(control);
				}
				  	
			}
		}
	}

	validateElement(control){
		var id = null;
		var text = '';
		var key = null;
		
		if(control.getAttribute('type') !== undefined){
			id = control.id;
			text = control.value;
			key = control.getAttribute('data-key');
		}else{
			const selectedIndex = control.options.selectedIndex;
			id = parseInt(control.options[selectedIndex].getAttribute('data-key'));
			text = control.options[selectedIndex].text;
			key = control.options[selectedIndex].getAttribute('data-key')
		}
		
		

		if(key !== null){
			
				this.state.analitical_test_list.map((test)=>{
					
					if(control.id === 'analitical_test_'+test.analitical_test.id){
						if(control.value !== ""){
							control.classList.remove('error')
						}

						test.highlight.map((h)=>{
							var index = test.results.findIndex(obj => 
								h.settled_tex_id === obj.id && obj.id === id
							);
							if(index !== -1){
								if(h.highlight){
									control.classList.add('error');
									return false;
								}else{
									control.classList.remove('error')
								}
							}
						})
						
					

						

						/*test.accepted_values.some((accept)=>{
							if(test.analitical_test.is_antibody){
							
								if(accept.settled_text_at_id === id && text === "POSITIVO"){
								
									control.classList.add('error')
									return accept.settled_text_at_id === id;
								}else{
									control.classList.remove('error')
								}
							}else{
								if(accept.settled_text_at_id === id){
									control.classList.remove('error')
									return accept.settled_text_at_id === id;
								}else{
									control.classList.add('error')
								}
								
							}
							
						})*/
					}
				})
			
		}else{
			if(control.required && control.value===""){
				control.classList.add('error');
		  	}
		}
	}

	validateInput(e) {
	    const re = /^[-+]?$/;
	    if (e.key === "Enter") {
      		e.preventDefault(); // Prevent form submission if button present
      		
      		const form = e.target.form;

      		const index = Array.prototype.indexOf.call(form, e.target);
      		if(form.elements[index + 1] !== undefined){

      			if(form.elements[index + 1].getAttribute("disabled") !== undefined){
    				if(form.elements[index + 1].getAttribute("disabled") === null)
    					form.elements[index + 1].focus();
    			
    				else if(form.elements[index + 1].getAttribute("disabled") === "")
    					form.elements[index + 2].focus();
    			}
      		}
    	
		    if (!re.test(e.key)) {
		      e.preventDefault();
		    }
		}
  	}

	render(){
		const { t } = this.props;
		
		return(
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>{this.state.lab_section_name}</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<form noValidate>
			        {this.state.opening?
			        	<div style={{textAlign:'center'}}>
							<Loader 
								type="Oval" 
								color="#64b5f6" 
								height={80} 
								width={80}
								/> 
						</div>:
			        	<div className="row" style={{padding:"0px 20px 0px 20px"}}>
			        		{/*HEADER*/}
							<div className="col-xs-12 col-sm-8 form-group">
								<label>Donante:</label><span style={{paddingLeft:"10px"}} className="theme-color">{this.state.data.donor_name}</span>
							</div>
							<div className="col-xs-12 col-sm-4 form-group">
								<label>Edad:</label><span style={{paddingLeft:"10px"}} className="theme-color">{this.state.data.donor_age}</span>
							</div>
							<div className="col-xs-12 col-sm-8 form-group">
								<label>
									{this.state.donation_id === 0 ? 
										"Muestra No."
									: "Donación No:"}
									
								</label>
								<span style={{paddingLeft:"10px"}} className="theme-color">
									{this.state.donation_id === 0 ?
										this.state.sample.number+', '
									: this.state.data.donation_number+', '}
									<Moment format="DD/MM/YYYY">{this.state.data.timestamp_date}</Moment>{' '}
			                  		{this.state.data.timestamp_hour!==null?
			                  			<Moment parse="HH:mm" format="h:mm a">{this.state.data.timestamp_hour}</Moment>:null}
								</span>
							</div>
							<div className="col-xs-12 col-sm-4 form-group">
								<button className="btn btn-info" disabled type="button">{this.state.data.sex}</button>
							</div>

							<div className="col-xs-12" style={{paddingTop:"20px"}}>
					        	{this.state.analitical_test_list.map((obj, index) =>{   
					            	return 	<div key={index} className="col-xs-12 form-group" >
					            				<div className="col-xs-8"  style={{padding:'0px'}}>
							        				<span>{obj.analitical_test.name}:</span>
							        			</div>
							        			{obj.type === "CUANTITATIVO"?
								        			<div className="col-xs-3" style={{padding:"0px"}}>
								        				<input type="number" step="0.001" className="form-control" required  
								        					onChange={ this.handleChange }
								        					data-key={obj.analitical_test.id}
								        					id={"analitical_test_"+obj.analitical_test.id} name={"analitical_test_"+obj.analitical_test.id}
								        					disabled={!this.state.data.section.modify_permission}
								        					onKeyPress={(e) => this.validateInput(e)}/>
								        			</div>
							        			:<div className="col-xs-3" style={{padding:"0px"}}>
							        					<select className="form-control" id={"analitical_test_"+obj.analitical_test.id}
							        						disabled={!this.state.data.section.modify_permission}
								        					onChange={ this.handleChange } onKeyPress={(e) => this.validateInput(e)}
											              	name={"analitical_test_"+obj.analitical_test.id} required>
											              	<option value="">Seleccionar...</option>
											                {
												                obj.results.map(function(t) {
												                  return <option key={t.id} data-key={t.id}  value={t.value} >{t.value} </option>;
												                })
											            	}
										              	</select>
												              	
							        				
							        			</div>
								        		}

								        		<div id={"mark_"+obj.analitical_test.id} className="col-xs-1" style={{color:"green", display:"none"}}>
											        	<SvgIcon icon={checkmark} style={{paddingTop:"3px"}}/>
											        </div>
					            			</div>
					            })
					            }
					          </div>
					    </div>}
				    </form>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.save')} 

		        		disabled={!this.state.can_save} onClick={this.save}/>
		        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
		);
	}
}

export default translate('translations')(ModalSingleValidation) 